export default __webpack_public_path__ + "static/what-we-do-c632231054ab09935d3785e998a37bde.jpg";